export default __webpack_public_path__ + "static/media/03.d67f6fca.svg";